// extracted by mini-css-extract-plugin
module.exports = {"root":"AppLink_root__cYrs2","underlined":"AppLink_underlined__1H4OI"};